import React from 'react';

export interface Currency {
  code: string;
  name: string;
  symbol: string;
}

export const SUPPORTED_CURRENCIES: Currency[] = [
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' }
];

interface CurrencySelectorProps {
  selectedCurrency: string;
  onCurrencyChange: (currency: string) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
  showSymbol?: boolean;
}

const CurrencySelector: React.FC<CurrencySelectorProps> = ({
  selectedCurrency,
  onCurrencyChange,
  disabled = false,
  className = '',
  id,
  showSymbol = true
}) => {
  const selectedCurrencyData = SUPPORTED_CURRENCIES.find(
    currency => currency.code === selectedCurrency
  ) || SUPPORTED_CURRENCIES[0]; // Default to GBP

  return (
    <div className={`currency-selector flex items-center ${className}`}>
      {showSymbol && (
        <span className="currency-symbol mr-2">
          {selectedCurrencyData.symbol}
        </span>
      )}
      <select
        id={id}
        data-testid={id}
        value={selectedCurrency}
        onChange={(e) => onCurrencyChange(e.target.value)}
        disabled={disabled}
        className="form-select input text-sm text-gray-900 placeholder-gray-400 truncate w-full whitespace-nowrap appearance-none"
        style={{ textWrap: 'nowrap' }}
      >
        {SUPPORTED_CURRENCIES.map((currency) => (
          <option key={currency.code} value={currency.code}>
            {currency.code} - {currency.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CurrencySelector;
